import { object, number, string, array, ObjectSchema, TestContext } from 'yup';
import { validationSchemaProps } from 'enums/ProductDistributionEnums';
interface TestContextExtended {
  from: Array<{
    schema: ObjectSchema;
    value: any;
  }>;
}

export const EndMarketList = [
  {
    name: 'end_market_location',
    placeholder: 'End Market Location',
    label: 'End Market Location',
    size: 'big',
    select: false,
    checkbox: false,
  },
  {
    name: 'units',
    placeholder: 'Quantity of goods sent to this location',
    label: 'Quantity of goods sent to this location',
    size: 'big',
    select: false,
    checkbox: false,
  },
  {
    name: 'transportation_air',
    placeholder: 'Check this box if transportation is via air',
    label: 'Check this box if transportation is via air',
    size: 'big',
    select: false,
    checkbox: true,
  },
];

export const topFields = [
  {
    name: 'totalPeriodUnits',
    placeholder: 'Reporting Period Production (units)',
    label: 'Reporting Period Production (units)',
    size: 'big',
    select: false,
    disabled: true,
    checkbox: false,
  },
  {
    name: 'processingFacilityTotal',
    placeholder: 'Total goods transported',
    label: 'Total goods transported',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'totalUnit',
    placeholder: 'Goods stored or sold in processing facility',
    label: 'Goods in processing facility',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'onlineRetail',
    placeholder: 'Goods sold via online retail',
    label: 'Goods sold via online retail',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
];

export const validationSchema = object().shape({
  totalPeriodUnits: number().required(validationSchemaProps.ERROR_MESSAGE),
  processingFacilityTotal: number()
    .typeError(validationSchemaProps.TYPE_ERROR)
    .notRequired()
    .test('sum-total-validation', "Value doesn't add up", function (value) {
      let sum: number | null | undefined = 0;
      const { totalPeriodUnits, totalUnit, onlineRetail } = this.parent;
      if (value === totalPeriodUnits) {
        sum = value;
      } else if (totalUnit && onlineRetail) {
        sum = value + totalUnit + onlineRetail;
      } else if (totalUnit) {
        sum = value + totalUnit;
      } else if (onlineRetail) {
        sum = value + onlineRetail;
      }
      return sum === totalPeriodUnits;
    }),
  totalUnit: number()
    .typeError(validationSchemaProps.TYPE_ERROR)
    .notRequired()
    .test('sum-total-validation', "Value doesn't add up", function (value) {
      if (value === undefined) {
        return true;
      }
      const { totalPeriodUnits, processingFacilityTotal, onlineRetail } =
        this.parent;
      const sum = processingFacilityTotal + value + onlineRetail;
      return sum === totalPeriodUnits;
    }),
  onlineRetail: number()
    .typeError(validationSchemaProps.TYPE_ERROR)
    .notRequired()
    .test('sum-total-validation', "Value doesn't add up", function (value) {
      if (value === undefined) {
        return true;
      }
      const { totalPeriodUnits, processingFacilityTotal, totalUnit } =
        this.parent;
      const sum = processingFacilityTotal + totalUnit + value;
      return sum === totalPeriodUnits;
    }),
    productDistributionRoute : array().of(
    object().shape({
      endMarketLocation: string().required(
        validationSchemaProps.ERROR_MESSAGE
      ),
      units: number()
        .required(validationSchemaProps.ERROR_MESSAGE)
        .typeError(validationSchemaProps.TYPE_ERROR)
        .test(
          'sum-routes-validation',
          'Value does not add up to Total Goods Transported',
          function () {
            const test = this as TestContext & TestContextExtended;
            const processingFacility = parseInt(
              test.from[1].value.processingFacilityTotal,
              10
            );
            const { from } = test;
            const units = from[1].value.productDistributionRoute;
            const totalUnits: number = units.reduce(
              (acc: number, route: { units: string }) => {
                const units: number = parseInt(route.units);
                return acc + units;
              },
              0
            );
            return totalUnits === processingFacility;
          }
        ),
    })
  ),
});
